import React, { useRef } from "react";
import { Divider, Typography } from "@mui/material";
import IntroductionImg3 from "../../../assets/SvgIcons/IntroductionImg3.svg";
import "../JaldiLab.css";
import {
  DashedBorderStyle,
  DividerBorderStyle,
  dimensionStyle,
  generateOrderedList,
  getTextContentWithHeading,
  h1style,
  h2style,
  h3style,
  paraStyle,
  referenceHtml,
  referenceStyle,
  referenceTootKit,
  sectionStyle,
} from "./ChapterList";
import CaptionWithBorders1 from "../../../components/ChapterImage/Image";
import managementAction from "../../../assets/Images/Management Policies Images/Mgmt_policies _action.jpg";
import managementProcess from "../../../assets/Images/Management Policies Images/Mgmt_policies_process.jpg";
import managementMonitoring from "../../../assets/Images/Management Policies Images/Mgmt_policies_monitoring.jpg";
import { FigureDesc76 } from "../../../utils/tmp/ImageDescription/ManagementPoliciesID";

function ManagementPoliciesStrategies({ goToSection }) {
  const referencesRef = useRef(null);

  const handleScrollToReferences = () => {
    if (referencesRef.current) {
      referencesRef.current.scrollIntoView({
        block: "center",
        inline: "nearest",
        behavior: "smooth",
      });
    }
  };

  const reference = (_data, number) => {
    return referenceTootKit(_data, number, handleScrollToReferences);
  };

  const referenceData = [
    {
      content:
        "For example, in 2015, a sniffer dog squad was brought to the Bombay High Court building to detect a possible bomb threat.",
      link: "",
      description: "",
    },
    {
      content: "NCMS Action Plan",
    },
    {
      content:
        "eCommittee of Supreme Court of India, ‘Policy and Action Plan Document: Phase II of the eCourts Project’ (2014) ",
      link: "https://ecourts.gov.in/ecourts_home/static/manuals/PolicyActionPlanDocument-PhaseII-approved-08012014-indexed_Sign.pdf",
      description:
        "eCommittee of Supreme Court of India, ‘Policy and Action Plan Document: Phase II of the eCourts Project’ (2014) <https://ecourts.gov.in/ecourts_home/static/manuals/PolicyActionPlanDocument-PhaseII-approved-08012014-indexed_Sign.pdf> p. 7. ",
    },
    {
      content:
        "eCommittee of Supreme Court of India, ‘Newsletter’ (November 2023) ",
      link: "https://cdnbbsr.s3waas.gov.in/s388ef51f0bf911e452e8dbb1d807a81ab/uploads/2024/01/202401191115037981.pdf",
      description:
        "<https://cdnbbsr.s3waas.gov.in/s388ef51f0bf911e452e8dbb1d807a81ab/uploads/2024/01/202401191115037981.pdf> p. 31. ",
    },
    {
      content: " eCourts Phase III Vision Document.",
    },
    {
      content:
        "eCommittee of Supreme Court of India, ‘eCourts Project Phase II: Objectives Accomplishment Report as per Policy Action Plan Document’ ",
      link: "https://ecourts.gov.in/ecourts_home/static/manuals/Objectives%20Accomplishment%20Report-eCourts-final_copy.pdf",
      description:
        "<https://ecourts.gov.in/ecourts_home/static/manuals/Objectives%20Accomplishment%20Report-eCourts-final_copy.pdf>",
    },

    {
      content:
        <><i>Justice K.S. Puttaswamy (Retd.) & Anr. v. Union of India</i> (2017) 10 SCC 1 (Supreme Court of India). </>,
    },

    {
      content: "Digital Personal Data Protection Act (2023), section 4.",
    },
  ];

  const DesignConsiderations = [
    <>
      Screening of both vehicles and users at two levels:
      <ol type="a">
        <li>
          {" "}
          Perimeter screening before entry into the sanitised area of the Court
          Complex (
          <span
            onClick={() =>
              goToSection("spacePlanningCirculation", "entrancesAndExits")
            }
            style={sectionStyle}
          >
            PART C, Sections 1.2 and 1.3
          </span>
          ); and{" "}
        </li>
        <li>
          {" "}
          Frisking with baggage and full body scanners before entry into any
          designated secure area of the Court building (
          <span
            onClick={() =>
              goToSection("spacePlanningCirculation", "entrancesAndExits")
            }
            style={sectionStyle}
          >
            PART C, Sections 1.2, 1.4-1.5
          </span>
          ).
        </li>
      </ol>
    </>,

    "Securing the building entrances and paths/lifts for judges, accused persons and vulnerable witnesses through use of CCTV surveillance systems. ",

    <>
      Using technologically advanced access control mechanisms with biometric or
      touch-free facial/retina screening at entry points to high security areas,
      such as the lock-ups and evidence storage rooms (
      <span
        onClick={() => goToSection("judicialLockUp", "lockups")}
        style={sectionStyle}
      >
        PART C, Sections 2.7.A
      </span>{" "}
      and{" "}
      <span
        onClick={() => goToSection("evidenceRoom", "HeadingEvidenceRoom")}
        style={sectionStyle}
      >
        2.9.D
      </span>
      ).
    </>,

    <>
      Within the Courtrooms and VWDCs, providing security features such as
      tinted glass for the accused to avoid direct confrontation with vulnerable
      witnesses (
      <span
        onClick={() => goToSection("courtroom", "special-courtrooms")}
        style={sectionStyle}
      >
        PART C, Sections 2.1.B
      </span>{" "}
      and{" "}
      <span onClick={() => goToSection("vwdc", "VWDC")} style={sectionStyle}>
        Section 2.3
      </span>
      ).
    </>,
    <>
      Adopting additional security subsystems such as mobile sniffers with
      signatures of explosives and chemical compounds, Hold and Disposal Bags
      for covering suspicious unhandled baggage or perceived explosives, etc.,
      depending on threat perceptions, particularly for Courts in border states
      or states with insurgency/naxalite threats.
      {reference(referenceData[0], 1)} For further details, please refer to
      <span
        onClick={() => goToSection("annexes", "HeadingAnnexure3")}
        style={sectionStyle}
      >
        {" "}
        Annexure 3
      </span>
      .
    </>,

    <>
      Coordinating with the Command and Control Centre for monitoring security
      protocols and undertaking coordinated evacuation activities (
      <span
        onClick={() =>
          goToSection("officeSpaces", "officeSpacesMultiPersonWorkspace")
        }
        style={sectionStyle}
      >
        PART C, Section 2.5.C
      </span>
      ).
    </>,
  ];
  return (
    <div>
      <Typography>
        <h1 id="handbookPrinciple" style={h1style}>
          PART D - IMPLEMENTATION, MONITORING & EVALUATION
        </h1>{" "}
        <h2 id="mainheading" style={h2style}>
          <span style={{ fontSize: "24px" }}>4. </span>RECOMMENDED MANAGEMENT
          POLICIES & STRATEGIES
        </h2>
        <p style={paraStyle}>
          This section lays down the policies and strategies that may be put in
          place to implement the recommendations provided in this Handbook. The
          policies and strategies have been recommended to aid the High Court
          Building Committees to look at District Court infrastructure in a
          holistic manner and to ensure that they formulate strategies and
          implementation policies with the long-term aim of ensuring accessible,
          adaptable, efficient, safe and comfortable, and sustainable judicial
          infrastructure. The recommended policies take into account existing
          standards and procedures and provide additional components to be taken
          into consideration wherever necessary.
        </p>
        <h5>Action: </h5>
        <CaptionWithBorders1
          image={[managementAction]}
          zoomImgStyle={{ height: "300px" }}
        />
        <h5>Process and Implementation:</h5>
        <CaptionWithBorders1
          image={[managementProcess]}
          // zoomImgStyle={{ height: "400px" }}
        />
        <h5>Monitoring and Evaluation: </h5>
        <CaptionWithBorders1
          image={[managementMonitoring]}
          caption="Figure 76: Steps to be taken to ensure implementation of management policies"
          creditLabel="Source"
          imageCredit="Greening Indian Cities Through Efficient Buildings, p. 24. "
          zoomImgStyle={{ height: "500px" }}
          imageDescription={FigureDesc76}
        />
        <DashedBorderStyle />
        <h3 id="security" style={h3style}>
          <span style={{ fontSize: "20px" }}>4.1. </span>Components of Security
          Policy for the District Judiciary
        </h3>
        <p style={paraStyle}>
          To ensure optimal use of the proposed systems and sub-systems, a
          Security and Administration Policy should be put in place after
          undertaking a review of the applicable (bye-)laws and regulations for
          each Court Complex in a particular jurisdiction. A Security Committee
          may be constituted at each High Court to undertake this exercise.
        </p>
        <p style={paraStyle}>
          The Committee may be structured to consist of representatives of the
          District Courts, the jurisdictional law enforcement agency, and the
          potential service providers of the sub-systems, including IT &
          Networking, Fire & Safety, Security, Facility Management System &
          Parking Management System as well as representatives of the Government
          Service Departments at the State-level such as the National
          Informatics Centre (“NIC”), the Centre for Development of Advanced
          Computing (“C-DAC”), Central Reserve Police Force (“CRPF”), Central
          Industrial Security Force (“CISF”), etc., who will render services to
          the Court.
        </p>
        <p style={paraStyle}>
          The Committee should periodically review the threat perception to the
          Court Complex and create Standard Operating Procedures (“SOPs”) and
          protocols for achieving its security goals. It should also regularly
          liaise with state & city law enforcement agencies, District Disaster
          Management Authorities and the Fire & Civil Defence Bodies while
          creating the SoPs.
        </p>
        <p style={paraStyle}>
          SOPs may be formulated to asses the following aspects:{" "}
        </p>
        {generateOrderedList(DesignConsiderations)}
        <DashedBorderStyle />
        <h3 id="dataManagement" style={h3style}>
          <span style={{ fontSize: "20px" }}>4.2. </span>Data Management
          Policies for the District Judiciary
        </h3>
        <h4 id="e-Courts" style={h3style}>
          <span style={{ fontSize: "20px" }}>4.2.</span>A. Systems for e-Courts
          Management
        </h4>
        <p style={paraStyle}>
          The use of Information & Communication Technology (“ICT”) in Court
          Complexes enables a seamless transition from a physical to a virtual
          Court. The e-Committee of the Supreme Court is tasked with overseeing
          the development of networking infrastructure and the adoption of
          digitisation of Court processes, with the aim of making the system
          accessible, cost-effective, efficient, transparent, and accountable.
        </p>
        <p style={paraStyle}>
          The Policy and Action Plan of the National Court Management System
          Committee (NCMS Committee){reference(referenceData[1], 2)} recommended
          setting up measurable performance standards for Courts, adoption of
          case management systems, standardisation of judicial data and
          statistics, and adoption of a human resource plan for Courts.
        </p>
        <p style={paraStyle}>
          However, the Phases I & II of the e-Courts project have not been very
          successful in ensuring that the benefits reach end-users, owing to
          uneven distribution of hardware and ICT resources,
          {reference(referenceData[2], 3)} and reluctance at the ground-level to
          adopt new technologies being introduced such as e-filing or National
          Service and Tracking of Electronic Processes (“N-STEP”), with users
          continuing to prefer traditional methods.
          {reference(referenceData[3], 4)}
        </p>
        <p style={paraStyle}>
          Phase III of the e-Courts Project has provided a unique opportunity to
          ensure that the policies envisioned in the earlier phases are
          actualised and end-users directly benefited. The 2023 Vision Document
          of Phase III articulates goals for putting in place digital
          infrastructure and services guided by core values of trust, empathy,
          sustainability, and transparency. It takes an “ecosystem approach”
          that leverages existing capacities in different stakeholders to
          realise its vision.{reference(referenceData[4], 5)}
        </p>
        <p style={paraStyle}>
          To operationalise these goals and the proposed “ecosystem approach”,
          the institutional and governance framework recommended in this Vision
          Document must be implemented by setting up the recommended Digital
          Courts Technology Office (“DCTO”) in the transitory stage, which will
          evolve to a statutory body, the National Judicial Technology Council
          (“NJTC”) that will focus on designing the Digital Infrastructure based
          on consultations with all necessary stakeholders.
        </p>
        <p style={paraStyle}>
          An efficient feedback mechanism should be set up to strengthen the
          feedback loops, ensure competencies and create clear accountability
          mechanisms for making justice more accessible, inclusive and efficient
          for everyone while adopting the innovative diverse solutions. For
          further details, please refer to{" "}
          <span
            onClick={() => goToSection("annexes", "HeadingAnnexure6")}
            style={sectionStyle}
          >
            Section 6
          </span>
          .
        </p>
        <p style={paraStyle}>
          Additionally, Hardware Infrastructure Systems, including physical
          wired and wireless infrastructure should be compliant as per the
          relevant Telecommunications Industry Association (“TIA”) Standards and
          Building Industry Consulting Service International (“BICSI”)
          recommendations.
        </p>
        <p style={paraStyle}>
          All Systems, Sub-systems and Devices deployed for automation of the
          in-premises services described under D 1, 2 & 3, should support
          appropriate APIs, preferably based on Open IOT platform standards, for
          smooth integration to a future Digital Public Infrastructure (“DPI”)
          based on e-Courts Management systems.
        </p>
        <DividerBorderStyle />
        <h4 id="record" style={h3style}>
          <span style={{ fontSize: "20px" }}>4.2.</span>B. Data and Records
          Management
        </h4>
        <p style={paraStyle}>
          Phases I and II of the e-Courts project of the e-Committee of the
          Supreme Court recommended the implementation of data management
          systems to develop Common Application Software with the help of the
          e-Committee for all District Courts, to ensure uniform structures
          through national codification processes for data collection.
          {reference(referenceData[5], 6)} To ensure that this is actualised, a
          comprehensive Data and Records Management Policy must be put in place
          to guide the digitisation efforts at the High Court and District Court
          level.
        </p>
        <p style={paraStyle}>
          Documentation of records (including pleadings, evidence, orders and
          judgments) involves indexing, authentication, and conversion of files
          into digital formats. Additionally, plaints, petitions, appeals and
          applications filed digitally via the e-Seva Kendra also need systems
          for generating receipts and stamps, and scrutinizing and preparing
          digital files. The recommended document management system should take
          these requirements into account and should be integrated with the
          overarching Case Management System of the Court.
        </p>
        <p style={paraStyle}>
          The Policy must also account for procedures for the retention, proper
          handling, and disposal of property and evidence. An evidence
          management system with advanced electronic mechanisms such as barcodes
          or Radio Frequency Identification (“RFID”) chips may be considered for
          efficient and secure management of evidence in Evidence Rooms (
          <span
            onClick={() => goToSection("evidenceRoom", "HeadingEvidenceRoom")}
            style={sectionStyle}
          >
            PART C, Section 2.9.D
          </span>
          ).
        </p>
        <p style={paraStyle}>
          Additionally, procedures for disposal of seized evidence in disposed
          cases must be put in place to maintain privacy and confidentiality of
          information along with mechanisms for archival of records, in
          accordance with the existing Civil and Criminal Rules of Procedure in
          each jurisdiction.
        </p>
        <p style={paraStyle}>
          Digitisation must also ensure that the data collected from all users
          may be made available in perpetuity while maintaining the sanctity of
          the data. While replicating an on-premise digital store onto a cloud
          infrastructure is the basic expectation, the DCTO must put in place
          protocols and integrate technologies such as Storage Area Network
          (“SAN”) servers for regular backups, data mirroring and cross cloud
          data management. The protocols should include retrieval of data from
          such backups as well as periodic data vulnerability assessments and
          Information Security Audits. Provisions should be made at the
          digitisation stage to account for these processes and the accompanying
          digital infrastructure that must be incorporated at the District
          Courts.
        </p>
        <p style={paraStyle}>
          While the guiding principle behind digitisation of data is
          accessibility & inclusiveness, Personal Data Protection & need based
          access must be an important consideration in compliance with the
          Supreme Court guidelines in the <i>Puttaswamy</i> case
          {reference(referenceData[6], 7)} and the Digital Personal Data{" "}
          Protection Act (2023).
          {reference(referenceData[7], 8)} This becomes even more paramount once
          the “ecosystem” approach proposed in the Vision Document becomes
          widespread and multiple external stakeholders start gaining access to
          judicial data & personal information of litigants and witnesses.
        </p>
        <h2 ref={referencesRef} id="reference" style={referenceStyle}>
          <i>References</i>
          <Divider />
        </h2>
        {referenceHtml(referenceData)}
      </Typography>
    </div>
  );
}

export default ManagementPoliciesStrategies;
